import React, {useEffect, useState, useContext} from "react";
import {useHistory} from "react-router-dom";

import styles from "./viewItem/ViewItem.module.scss"
import appContext from "../../../../../context/appContext";

const ViewItem = ({handleTriggerShowModal, disabledCostProperty}) => {

    const [view, setView] = useState(null);
    const [selectedId, setSelectedId] = useState(null);

    const history = useHistory();

    const context = useContext(appContext);

    const [data, setData] = useState([]);

    useEffect(() => {
      setData([
        {
          id: 1,
          icon: 'frequency',
          title: 'Frequency View',
          options: [
            {
              id: 31,
              name: 'Case Count',
              value: 'caseCount'
            },
            {
              id: 32,
              name: 'Total Count',
              value: 'totalCount'
            },
          ]
        },
        {
          id: 2,
          icon: 'duration',
          title: 'Duration View',
          options: [
            {
              id: 11,
              name: 'Min',
              value: 'min'
            },
            {
              id: 12,
              name: 'Max',
              value: 'max'
            },
            {
              id: 13,
              name: 'Average',
              value: 'average'
            },
            {
              id: 14,
              name: 'Total',
              value: 'total'
            }
          ]
        },
        {
          id: 3,
          icon: 'rework',
          title: 'Rework View',
          options: [
            {
              id: 21,
              name: 'Loop',
              value: 'loop'
            },
            {
              id: 22,
              name: 'Self-Loops',
              value: 'selfLoops'
            },
          ]
        },
        {
          id: 4,
          icon: 'cost',
          title: 'Cost View',
          disabled: disabledCostProperty,
          options: [
            {
              id: 52,
              name: 'Average Cost',
              value: 'averageCost'
            },
            {
              id: 51,
              name: 'Total Cost',
              value: 'totalCost'
            },
          ]
        },
        {
          id: 5,
          title: 'BPMN View',
          options: [
            {
              id: 33,
              name: 'Generate a BPMN Model',
              value: 'generateBpmnModel',
              onClick: () => {
                context.handleAddTab(11, "Generate BPMN Model", "generate-bpmn-model");
                history.push('/generate-bpmn-model');
              }
            }
          ]
        }
      ])
    }, [disabledCostProperty])

    useEffect(() => {
      if (data.length) {
        const newData = [...data];
        const findData = newData.find(item => item.title === "BPMN View");
        history.location.pathname === "/process-explorer" || history.location.pathname === "/process-compare"
          ? findData.disabled = true : findData.disabled = false;
        setData(newData)
      }
    }, [history.location.pathname])

    const handleAddView = (val, id, click = null) => {
      handleTriggerShowModal();
      setTimeout(() => {
        if (val !== "generateBpmnModel") {
          if (history.location.pathname === '/process-explorer')
            context.dispatch({type: 'set_process_explorer_view', value: val})
          else
            context.selectView(history.location.pathname, val);
          setView(val);
          setSelectedId(id);
        }
        if (click) {
          click();
        }
      }, 100);
    }

    useEffect(() => {
      handleAddView("caseCount", 1)
    }, [data]);

    useEffect(() => {
      if (view) {
        data.forEach(item => {
          item.options.forEach(option => {
            if (option.value === view) {
              setSelectedId(item.id);
            }
          })
        })
      }
    }, [view]);

    useEffect(() => {
      if (history.location.pathname === '/process-explorer') {
        setView(context.state.processExplorerView);
      } else if (history.location.pathname === '/process-compare') {
        setView(context.processCompareView);
      } else {
        setView(context.view)
      }
    }, [context.view, context.state.processExplorerView, context.processCompareView, history.location.pathname]);

    const showItems = data.map(item => (
      <div key={`${item.id}_${item.title}`}
           className={[styles.ViewItem, !item.icon ? 'mt-4' : null, selectedId === item.id ? styles.active : null, item.disabled && styles.disabled].join(' ')}>
        {
          item.icon ? (
            <div className={[styles.icon, 'd-flex align-items-center justify-content-center'].join(' ')}>
              {
                item.icon === 'duration' && (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.2" cx="12" cy="12" r="10" fill="#C2C7ED"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M21.2498 12.0005C21.2498 17.1095 17.1088 21.2505 11.9998 21.2505C6.89076 21.2505 2.74976 17.1095 2.74976 12.0005C2.74976 6.89149 6.89076 2.75049 11.9998 2.75049C17.1088 2.75049 21.2498 6.89149 21.2498 12.0005Z"
                          stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.4314 14.9429L11.6614 12.6939V7.84689" stroke="#200E32" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                )
              }
              {
                item.icon === 'rework' && (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.2" cx="12" cy="12" r="10" fill="#C2C7ED"/>
                    <path
                      d="M21.4 12.0016C21.4 17.1927 17.19 21.4 11.9984 21.4C6.80709 21.4 2.6 17.1929 2.6 12.0016C2.6 6.80697 6.80722 2.6 11.9984 2.6C17.1899 2.6 21.4 6.80722 21.4 12.0016Z"
                      stroke="#060F36" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path
                      d="M11.6641 17.9917C11.7513 18.0952 11.8745 18.15 12.0001 18.15C12.1085 18.15 12.2161 18.1091 12.3007 18.029L12.3008 18.029C12.4812 17.8581 12.4957 17.569 12.3359 17.3794C12.3359 17.3794 12.3359 17.3794 12.3359 17.3794L11.808 16.7529H12C14.848 16.7529 17.15 14.2991 17.15 11.3015C17.15 8.30378 14.848 5.85 12 5.85C9.15203 5.85 6.85 8.30378 6.85 11.3015C6.85 11.5496 7.04179 11.7659 7.29656 11.7659C7.55133 11.7659 7.74312 11.5495 7.74312 11.3015C7.74312 8.79944 9.66103 6.7789 12 6.7789C14.339 6.7789 16.2569 8.79946 16.2569 11.3015C16.2569 13.8035 14.339 15.824 12 15.824H11.808L12.3359 15.1975C12.3359 15.1975 12.3359 15.1975 12.3359 15.1975C12.4957 15.0079 12.4812 14.7189 12.3008 14.548C12.1152 14.3722 11.8281 14.3906 11.6641 14.5852L11.7788 14.6819L11.6641 14.5852L10.6125 15.8334L10.7272 15.9301L10.6125 15.8334C10.3933 16.0936 10.3933 16.4834 10.6125 16.7435L10.7272 16.6469L10.6125 16.7435L11.6641 17.9917ZM11.6641 17.9917L11.7788 17.895L11.6641 17.9917L11.6641 17.9917Z"
                      fill="#060F36" stroke="#060F36" stroke-width="0.3"/>
                  </svg>
                )
              }
              {
                item.icon === 'frequency' && (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.2" cx="12" cy="12" r="10" fill="#C2C7ED"/>
                    <path
                      d="M21.4 12.0016C21.4 17.1927 17.19 21.4 11.9984 21.4C6.80709 21.4 2.6 17.1929 2.6 12.0016C2.6 6.80697 6.80722 2.6 11.9984 2.6C17.1899 2.6 21.4 6.80722 21.4 12.0016Z"
                      stroke="#200E32" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                )
              }
              {
                item.icon === 'cost' && (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="9.4" fill="#C2C7ED" fillOpacity="0.2" stroke="#0A195C"
                            stroke-width="1.2"/>
                    <g clipPath="url(#clip0_4074_38629)">
                      <path
                        d="M10.9661 6C11.3728 6.00039 11.7628 6.16214 12.0504 6.44973C12.338 6.73733 12.4997 7.12728 12.5001 7.534C12.5001 7.6666 12.5528 7.79378 12.6466 7.88755C12.7403 7.98132 12.8675 8.034 13.0001 8.034C13.1327 8.034 13.2599 7.98132 13.3537 7.88755C13.4474 7.79378 13.5001 7.6666 13.5001 7.534V7.5C13.5001 7.4905 13.5001 7.482 13.5001 7.4725C13.4834 6.81136 13.2092 6.18289 12.7358 5.72102C12.2625 5.25916 11.6275 5.00044 10.9661 5H10.5001V4.5C10.5001 4.36739 10.4474 4.24021 10.3537 4.14644C10.2599 4.05267 10.1327 4 10.0001 4C9.86751 4 9.74034 4.05267 9.64657 4.14644C9.5528 4.24021 9.50012 4.36739 9.50012 4.5V5H9.03412C8.43278 5.00064 7.85127 5.21511 7.39352 5.60509C6.93577 5.99506 6.63163 6.53511 6.53545 7.12871C6.43927 7.72231 6.55733 8.33077 6.86852 8.84533C7.17971 9.35989 7.66375 9.74701 8.23412 9.9375L9.50012 10.36V14H9.03412C8.6274 13.9996 8.23745 13.8379 7.94986 13.5503C7.66226 13.2627 7.50052 12.8727 7.50012 12.466C7.50012 12.3334 7.44744 12.2062 7.35368 12.1124C7.25991 12.0187 7.13273 11.966 7.00012 11.966C6.86751 11.966 6.74034 12.0187 6.64657 12.1124C6.5528 12.2062 6.50012 12.3334 6.50012 12.466V12.5C6.50012 12.5095 6.50012 12.518 6.50012 12.5275C6.51681 13.1886 6.79105 13.8171 7.2644 14.279C7.73776 14.7408 8.37278 14.9996 9.03412 15H9.50012V15.5C9.50012 15.6326 9.5528 15.7598 9.64657 15.8535C9.74034 15.9473 9.86751 16 10.0001 16C10.1327 16 10.2599 15.9473 10.3537 15.8535C10.4474 15.7598 10.5001 15.6326 10.5001 15.5V15H10.9661C11.5675 14.9994 12.149 14.7849 12.6067 14.3949C13.0645 14.0049 13.3686 13.4649 13.4648 12.8713C13.561 12.2777 13.4429 11.6692 13.1317 11.1547C12.8205 10.6401 12.3365 10.253 11.7661 10.0625L10.5001 9.64V6H10.9661ZM11.4511 11.0105C11.7968 11.1256 12.0903 11.3599 12.279 11.6716C12.4677 11.9833 12.5392 12.352 12.4809 12.7117C12.4225 13.0713 12.2381 13.3985 11.9605 13.6345C11.683 13.8706 11.3305 14.0001 10.9661 14H10.5001V10.6935L11.4511 11.0105ZM9.50012 9.3065L8.55012 8.9895C8.20449 8.87446 7.91108 8.64018 7.72239 8.32859C7.5337 8.01699 7.46206 7.64842 7.52027 7.28883C7.57849 6.92924 7.76277 6.60211 8.04014 6.36597C8.3175 6.12983 8.66985 6.0001 9.03412 6H9.50012V9.3065Z"
                        fill="#0A195C"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_4074_38629">
                        <rect width="12" height="12" fill="white" transform="translate(4 4)"/>
                      </clipPath>
                    </defs>
                  </svg>
                )
              }
            </div>
          ) : null
        }
        <div className={styles.title}>
          <span>{item.title}</span>
        </div>
        <div className={[styles.options, 'd-flex'].join(' ')}>
          {
            item.options.map(option => (
              <div key={`${option.id}_${option.name}`} >
                <span key={option.id} onClick={() => handleAddView(option.value, item.id, option.onClick)} className={(view === option.value) ? styles.selected : null}>
                  {option.name}
                </span>
              </div>
            ))
          }
        </div>
      </div>
    ));

    return (
      <>
        {showItems}
      </>
    )
  }
;

export default ViewItem;
